import { StrictMode, type ComponentType } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from '@/App'
import { IconSprite, ToastProvider } from '@/ui'
import '@/styles/app.css'
import '@/ui/theme-v33.css' // restyle A · the merchant v3.3 theme; after app.css so it follows the brand tokens

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000 } },
})

/* The seam’s mock side — dev and VITE_MOCK=1 builds only (FQ-C9): a production
   build ships neither the worker nor the world dial. Connecting the real Worker =
   removing this block and the src/mocks folder — screens never know the difference. */
const MOCK = import.meta.env.DEV || import.meta.env.VITE_MOCK === '1'
let WorldSwitcher: ComponentType = () => null
if (MOCK) {
  const [{ worker }, ws] = await Promise.all([import('@/mocks/browser'), import('@/mocks/WorldSwitcher')])
  await worker.start({ onUnhandledRequest: 'bypass' })
  WorldSwitcher = ws.WorldSwitcher
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <IconSprite />
          <App />
          <WorldSwitcher />
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
